import type {
  JobPostingPackage,
} from '../../../../reducers/packages/packages'
import type {
  JobPostingProduct,
  JobPostingEntitlement,
} from '../../../../reducers/entitlement/entitlement'

import {
  packageDefinitionsAreEqual,
  productDefinitionsAreEqual,
} from '../../../../../util/get-definition/getDefinition'

export const getEntitlementByJobPostingPackage = (
  entitlements: JobPostingEntitlement[],
  jobPostingPackage: JobPostingPackage | JobPostingEntitlement,
): JobPostingEntitlement | undefined =>
  entitlements.find((entitlement: JobPostingEntitlement): boolean =>
    // @ts-ignore
    packageDefinitionsAreEqual(jobPostingPackage, entitlement),
  )

export const getEntitlementByJobPostingProduct = (
  entitlements: JobPostingEntitlement[],
  jobPostingProduct: JobPostingProduct,
): JobPostingEntitlement | undefined =>
  entitlements.find((entitlement: JobPostingEntitlement): boolean =>
    productDefinitionsAreEqual(jobPostingProduct, entitlement.product),
  )

